/* Artemis - AJAX faceting for the collection grid (and any page with the same [data-col-root]
   scaffold). Filters, sort, price, active-pill removal, clear-all, and pagination all apply
   WITHOUT a full reload, via the Section Rendering API. The key mobile win: the filter drawer
   stays open while you tick multiple filters (native submit reloaded and closed it every time).

   Graceful degradation: the inline handlers call `window.aFacet(form)` only if this script loaded;
   otherwise they fall back to `this.form.submit()`. Links work as normal navigation without JS. */
(function () {
  var ROOT_SEL = '[data-col-root]';

  function root() { return document.querySelector(ROOT_SEL); }
  function sectionId() {
    var r = root();
    return (r && r.getAttribute('data-col-section')) || 'main-collection';
  }

  /* Carry the current page's preview/session params onto a target URL (see window.aUrl in artemis.js):
     on the theme preview the myshopify domain 301-redirects to the primary domain unless _fd=0 is
     present, which breaks a same-origin fetch. Delegates to the shared helper; falls back if absent. */
  function withSession(rawUrl) {
    if (window.aUrl) return window.aUrl(rawUrl);
    var u = new URL(rawUrl, location.origin);
    var cur = new URLSearchParams(location.search);
    ['preview_theme_id', '_fd', 'pb'].forEach(function (k) {
      if (cur.has(k) && !u.searchParams.has(k)) u.searchParams.set(k, cur.get(k));
    });
    return u.pathname + u.search;
  }

  /* Replace the innerHTML of a live region from the fetched document. */
  function swapRegion(doc, sel) {
    var next = doc.querySelector(sel);
    var here = document.querySelector(sel);
    if (next && here) here.innerHTML = next.innerHTML;
  }

  /* Swap the facet inputs (counts/checked/disabled all change as filters narrow) while preserving
     each <details> open/closed state and the drawer's scroll position, so the panel doesn't jump. */
  function swapFacets(doc) {
    var here = document.querySelector('[data-col-facets]');
    var next = doc.querySelector('[data-col-facets]');
    if (!here || !next) return;
    var open = Array.prototype.map.call(here.querySelectorAll('details'), function (d) { return d.open; });
    var scroller = here.closest('.a-facets');
    var top = scroller ? scroller.scrollTop : 0;
    here.innerHTML = next.innerHTML;
    Array.prototype.forEach.call(here.querySelectorAll('details'), function (d, i) {
      if (typeof open[i] === 'boolean') d.open = open[i];
    });
    if (scroller) scroller.scrollTop = top;
  }

  var loading = false;

  function load(rawUrl, opts) {
    opts = opts || {};
    if (loading) return Promise.resolve();
    loading = true;
    var r = root();
    if (r) r.setAttribute('aria-busy', 'true');
    var url = withSession(rawUrl);
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'section_id=' + sectionId(), { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        swapRegion(doc, '[data-col-results]');
        swapRegion(doc, '[data-col-active]');
        swapRegion(doc, '[data-col-count]');
        swapFacets(doc);
        refreshBulkControls();
        applyBulk();
        if (opts.push !== false) history.pushState({ facet: true }, '', url);
        if (opts.scroll) {
          var res = document.querySelector('[data-col-results]');
          if (res) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function () { /* network/preview failure: leave the page as-is */ })
      .finally(function () {
        loading = false;
        if (r) r.removeAttribute('aria-busy');
      });
  }

  /* Build a URL from a GET form (facets or sort), dropping empty values, and load it. */
  window.aFacet = function (form) {
    var base = form.getAttribute('action') || location.pathname;
    var data = new FormData(form);
    var qs = [];
    data.forEach(function (value, key) {
      if (value !== '' && value != null) qs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    var url = base.split('?')[0] + (qs.length ? '?' + qs.join('&') : '');
    load(url);
  };

  /* Delegated: intercept active-pill removal, clear-all, and pagination links (all inside the root). */
  document.addEventListener('click', function (e) {
    if (!root() || !window.aFacet) return;
    var a = e.target.closest('a[href]');
    if (!a || !root().contains(a)) return;
    var isPage = a.classList.contains('a-pagination__link');
    var isFacetLink = a.classList.contains('a-pill') || a.classList.contains('a-facets__clear');
    if (!isPage && !isFacetLink) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return; // let modified clicks open normally
    e.preventDefault();
    load(a.getAttribute('href'), { scroll: isPage });
  });

  /* Back/forward: re-render the section for the popped URL without pushing a new entry. */
  window.addEventListener('popstate', function () {
    if (!root()) return;
    load(location.pathname + location.search, { push: false });
  });

  /* ---- Bulk & case: client-side facet + rank over the loaded grid ----
     data-pack on each card is the units-per-pack count (0 = single). "Bulk & case first" moves packs
     to the front of the current page; "Bulk & case only" hides singles. State lives on the root as
     data-bulk-sort / data-bulk-filter so it survives an AJAX facet swap; the controls reveal only when
     the loaded page actually contains packs. Whole-collection coverage needs merch.pack_count exposed
     as a Search & Discovery filter; this ranks/filters the loaded grid today. */
  function bulkGrid() { return document.querySelector('[data-col-results] .a-grid-products'); }
  function packOf(card) { return parseInt(card.getAttribute('data-pack'), 10) || 0; }
  function applyBulk() {
    var grid = bulkGrid();
    if (!grid) return;
    if (!grid._bulkOrder) grid._bulkOrder = Array.prototype.slice.call(grid.querySelectorAll('.a-card'));
    var order = grid._bulkOrder;
    var r = root();
    var wantSort = r && r.getAttribute('data-bulk-sort') === '1';
    // The "only" chip is gone (see main-collection.liquid): filtering the loaded page is not
    // filtering the collection. The flag is still read so a stale data-bulk-filter="1" on a
    // bookmarked URL cannot leave a grid permanently hiding two thirds of its products.
    var wantFilter = false;
    var hasPacks = order.some(function (c) { return packOf(c) > 1; });
    var doFilter = wantFilter && hasPacks; // never blank the whole grid
    order.forEach(function (c) { c.classList.toggle('is-bulk-hidden', doFilter && packOf(c) < 2); });
    var seq = order;
    if (wantSort && hasPacks) {
      seq = order.map(function (c, i) { return { c: c, n: packOf(c), i: i }; })
        .sort(function (a, b) { return b.n - a.n || a.i - b.i; })
        .map(function (o) { return o.c; });
    }
    seq.forEach(function (c) { grid.appendChild(c); });
  }
  function refreshBulkControls() {
    var ctrl = document.querySelector('[data-bulk-controls]');
    if (!ctrl) return;
    var grid = bulkGrid();
    var any = grid && Array.prototype.some.call(grid.querySelectorAll('.a-card'), function (c) { return packOf(c) > 1; });
    ctrl.hidden = !any;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bulk-sort],[data-bulk-filter]');
    if (!btn) return;
    var r = root();
    if (!r) return;
    var attr = btn.hasAttribute('data-bulk-sort') ? 'data-bulk-sort' : 'data-bulk-filter';
    var on = r.getAttribute(attr) === '1';
    r.setAttribute(attr, on ? '0' : '1');
    btn.setAttribute('aria-pressed', on ? 'false' : 'true');
    applyBulk();
  });
  function initBulk() { refreshBulkControls(); applyBulk(); }
  if (document.readyState !== 'loading') initBulk(); else document.addEventListener('DOMContentLoaded', initBulk);
})();
